import { Stack, useTheme } from '@mui/material';

import { RiHotelFill } from 'react-icons/ri';
import { NavCollapseButton } from 'src/layouts/dashboard/navbar/member/NavbarCollapseButton';
import { NavbarMemberMainButton } from 'src/layouts/dashboard/navbar/member/NavbarMemberMainButton';
import { NavbarMemberSubButton } from 'src/layouts/dashboard/navbar/member/NavbarMemberSubButton';
import { useRouter } from 'next/router';
import { ContractPlan, DeleteStatus, UserStatus } from 'src/API';
import { BUTTON_HOVER_SHADOWS } from 'src/theme/shadows';
import { mainNavbarConfig, subNavbarConfig } from 'src/layouts/dashboard/navbar/config';
import Link from 'next/link';
import { useOrganization } from 'src/contexts/OrganizationContext';

export const NavbarMemberContents = () => {
  const { organization, currentUser, isLoading } = useOrganization();
  const router = useRouter();
  const theme = useTheme();

  // ローディング中またはorganizationがない場合は何も表示しない
  if (isLoading || !organization) {
    return null;
  }

  const oneOnOneMainNavbarConfig = mainNavbarConfig.filter((c) => c.title !== '評価');
  const customMemberNavbar = (data = mainNavbarConfig) =>
    data.map((m) => {
      const isActive = router.pathname === m.href;
      return (
        <Link
          href={{ pathname: m.href, query: { organizationName: organization.name } }}
          key={m.id}
        >
          <NavbarMemberMainButton
            key={m.title}
            startIcon={m.icon}
            sx={
              isActive
                ? {
                    backgroundColor: theme.palette.background.default,
                    color: theme.palette.text.primary,
                    // hover時の影
                    filter: BUTTON_HOVER_SHADOWS,
                    fontWeight: 'bold',
                    // hover時のアイコンの色をメインカラーに変更
                    '& .MuiButton-startIcon': {
                      color: theme.palette.primary.main,
                    },
                  }
                : {}
            }
          >
            {m.title}
          </NavbarMemberMainButton>
        </Link>
      );
    });

  return (
    <Stack gap="8px">
      <Stack px="16px" gap="8px">
        {organization.contractPlan === ContractPlan.OneOnOne
          ? customMemberNavbar(oneOnOneMainNavbarConfig)
          : customMemberNavbar()}
      </Stack>
      <Stack px="12px">
        <NavCollapseButton title={organization.name} icon={<RiHotelFill size={18} />}>
          <Stack gap="8px">
            {subNavbarConfig
              .filter((link) => !(currentUser?.myMembers?.items.length === 0 && link.id === 5)) // 部下がいない場合、「マネジメントレポート」を非表示
              .map((s) => {
                const isActive = router.pathname === s.href;
                // マネジメントレポートの場合、最初の部下のmemberIdをクエリに追加
                const isManagementReport = s.id === 5;
                const firstSubordinateMemberId =
                  currentUser?.myMembers?.items?.find((item) => {
                    const isValidSubordinate =
                      item?.member?.status === UserStatus.ActivateComplete &&
                      item?.member?.deleteStatus === DeleteStatus.notDeleted;
                    return isValidSubordinate;
                  })?.memberID ?? undefined;
                const query = isManagementReport
                  ? { organizationName: organization.name, memberId: firstSubordinateMemberId }
                  : { organizationName: organization.name };
                return (
                  <Link href={{ pathname: s.href, query }} key={s.id}>
                    <NavbarMemberSubButton
                      key={s.title}
                      sx={
                        isActive
                          ? {
                              backgroundColor: theme.palette.background.default,
                              color: theme.palette.text.primary,
                              // hover時の影
                              fontWeight: 'bold',
                            }
                          : {}
                      }
                    >
                      {s.title}
                    </NavbarMemberSubButton>
                  </Link>
                );
              })}
          </Stack>
        </NavCollapseButton>
      </Stack>
    </Stack>
  );
};
